/**
 * Created by PRIME AI.
 * @author Samuel Hinchliffe <samuel@primeai.co.uk, sam.hinchliffe.work@gmail.com>
 * @see    [Linkedin] {@link https://www.linkedin.com/in/samuel-hinchliffe-2bb5801a5/}
 *
 * @summary A simple Analytics class to make POSTing to the events apis easier.
 *
 * Created at: 27/10/2023
 * @see       [PRIME-AI GITHUB] {@link https://github.com/PRIME-AI-GITHUB}
 * @see       [Website]         {@link https://www.primeai.co.uk/}
 * @copyright 2018-2023 PRIME AI LTD
*/
import AppFactory from '../src/AppFactory';
import Log from './Log';

export default class Analytics {
    constructor(config, productId) {
        this.endPoint = config.urls.apis.event_trigger_api;
        this.config = config;
        this.productId = productId;
    }

    async registerEvent(event, customViews = 1, appName = '') {
        try {
            if (!appName) throw new Error('No App Name Provided');
            const response = await fetch(
                this.endPoint,
                {
                    method: 'POST',
                    body: JSON.stringify({
                        request: {
                            event_name: event,
                            appName,
                            device: AppFactory.getUserDevice(),
                            custom_views: customViews,
                            dorsia_retailer_id: '',
                            product_id: this.productId,
                            allow_any_event: true,
                        },
                        retailer_details: {
                            retailer_url: this.config.retailer_id,
                            host_retailer_id: this.config.retailer_id,
                            shopify_store: 'false',
                            retailer_id: this.config.retailer_id,
                        },
                    }),
                },
            );
            const result = await response.json();
            console.log(...Log.w('Analytics', 'LOG', `Logged ${event} with ${customViews} occurred`));

            return result;
        } catch (error) {
            console.warn(error);
            console.log(...Log.w('Analytics', 'WARN', `Logged ${event} with ${customViews} occurred`));
        }
        return false;
    }
}
